function initCarouselState(element) {
  const elements = element.querySelectorAll('.element-wrapper');
  const elementTextWrapper = element.querySelectorAll('.image-text-wrapper');

  const numberOfElements = elements.length;
  let currentElementIndex = 0;

  setNavigationArrowsFunctions();
  setNavigationDotsFunctions();
  prepareElementsNavigation();
  initSwipeEvents();
  handleElementChange(currentElementIndex);

  function setNavigationDotsFunctions() {
    const dots = element.querySelectorAll('.dot');

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        handleElementChange(idx);
      });
    })
  }

  function setNavigationArrowsFunctions() {
    const prevArrow = element.querySelector('.prev');
    const nextArrow = element.querySelector('.next');

    prevArrow.addEventListener('click', () => {
      handleElementChange(currentElementIndex - 1);
    });

    nextArrow.addEventListener('click', () => {
      handleElementChange(currentElementIndex + 1);
    });
  }

  function setActiveDot() {
    const dotElements = element.querySelectorAll('.dot');

    dotElements.forEach((dot, idx) => {
      if (idx === currentElementIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    })
  }

  function setActiveText() {
        const mainImage = Array.from(elements).find(el => el.classList.contains('main'));
      Array.from(elementTextWrapper).forEach(el => el.classList.remove('active'))
      if (mainImage) {   
        const matchingElement = Array.from(elementTextWrapper).find(el => el.getAttribute('data-key') === mainImage.getAttribute('data-key'))
        matchingElement.classList.add('active')
      }
    
  }
  
  

  function handleElementChange(newIndex) {
    currentElementIndex = clampIndex(numberOfElements - 1, newIndex);
    let indexesArray = [];
    let elementClasses = [];

    if (numberOfElements < 3) {
      indexesArray = [clampIndex(numberOfElements - 1, currentElementIndex)];
      elementClasses = ['main'];
    } else if (numberOfElements < 5) {
      indexesArray = [clampIndex(numberOfElements - 1, currentElementIndex - 1), clampIndex(numberOfElements - 1, currentElementIndex), clampIndex(numberOfElements - 1, currentElementIndex + 1)];
      elementClasses = ['prev1', 'main', 'next1'];
    } else {
      indexesArray = [clampIndex(numberOfElements - 1, currentElementIndex - 2), clampIndex(numberOfElements - 1, currentElementIndex - 1), clampIndex(numberOfElements - 1, currentElementIndex), clampIndex(numberOfElements - 1, currentElementIndex + 1), clampIndex(numberOfElements - 1, currentElementIndex + 2)];
      elementClasses = ['prev2', 'prev1', 'main', 'next1', 'next2'];
    }

    elements.forEach((element, idx) => {
      element.classList.remove(...elementClasses);

      if (indexesArray.includes(idx)) {
        element.classList.remove('prepare');
        element.classList.add(elementClasses[indexesArray.indexOf(idx)]);
      } else {
        element.classList.add('prepare');
      }
    });

    setActiveText();
    setActiveDot();
  }

  function prepareElementsNavigation() {
    elements.forEach(element => {
      element.addEventListener('click', handleElementClick);
    })
  }

  function handleElementClick(e) {
    const classList = e.target.classList;
    if (classList.contains('prev2')) {
      handleElementChange(currentElementIndex - 2);
    } else if (classList.contains('prev1')) {
      handleElementChange(currentElementIndex - 1);
    } else if (classList.contains('next1')) {
      handleElementChange(currentElementIndex + 1);
    } else if (classList.contains('next2')) {
      handleElementChange(currentElementIndex + 2);
    }
  }

  function initSwipeEvents() {
    let startX = 0;
    let endX = 0;
    let isMoving = false;

    const minSwipeDistance = 100;

    element.addEventListener('touchstart', function (event) {
      isMoving = false;
      startX = event.touches[0].clientX;
    });

    element.addEventListener('touchmove', function (event) {
      endX = event.touches[0].clientX;
      isMoving = true;
    });

    element.addEventListener('touchend', function () {
      if (isMoving) {
        const distanceX = endX - startX;

        if (distanceX > minSwipeDistance) {
          handleElementChange(currentElementIndex - 1);
        } else if (distanceX < -minSwipeDistance) {
          handleElementChange(currentElementIndex + 1);
        }
      }
    });
  }
}

function clampIndex(max, value) {
  return ((value % (max + 1)) + (max + 1)) % (max + 1);
}

export function initCarousels() {
  document.querySelectorAll('.carousel-wrapper').forEach(c => initCarouselState(c));
}
